/** Resolve league id from router params with pathname fallback for nested LSC routes. */
export function resolveActiveLeagueId(
  params: { leagueId?: string },
  pathname: string
): string | undefined {
  if (params.leagueId) {
    return params.leagueId;
  }

  const segments = pathname.split('/').filter(Boolean);
  const leaguesIndex = segments.indexOf('leagues');
  if (leaguesIndex < 0) {
    return undefined;
  }

  const candidate = segments[leaguesIndex + 1];
  if (!candidate || candidate === 'new') {
    return undefined;
  }

  return candidate;
}
